import { Component, TemplateRef, ViewChild } from "@angular/core";
import { NgbModal, NgbModalOptions, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { VehicleService } from "../../services/vehicle.service";

@Component({
  selector: "app-cancellation-policy-modal",
  templateUrl: "./cancellation-policy-modal.component.html",
  styleUrl: "./cancellation-policy-modal.component.scss",
  standalone: false
})
export class CancellationPolicyModalComponent {
  policyModalRef!: NgbModalRef;
  cancellationPolicy: any[] = [];
  config: NgbModalOptions = { size: "md", centered: true, backdrop: "static" };

  @ViewChild("template", { static: true }) template!: TemplateRef<any>;

  constructor(private modalService: NgbModal, private vehicleService: VehicleService) {}

  /**
   * Opens the cancellation policy modal for a specific vehicle.
   * Fetches the cancellation policy list for the given vehicle ID.
   *
   * @param vehicleId The ID of the vehicle for which to fetch the cancellation policy.
   */
  openModal(vehicleId: string): void {
    this.getCancellationPolicyList(vehicleId);
  }

  /**
   * Fetches the cancellation policy list for a specific vehicle.
   * Opens the modal with the fetched cancellation policy data.
   *
   * @param vehicleId The ID of the vehicle for which to fetch the cancellation policy.
   */
  getCancellationPolicyList(vehicleId: string): void {
    this.vehicleService.getCancellationPolicy(vehicleId).subscribe((response: any) => {
      if (response) {
        this.cancellationPolicy = response.cancellationPolicy;
        this.policyModalRef = this.modalService.open(this.template, this.config);
        this.policyModalRef.result.then(
          () => this.closeModal(),
          () => this.closeModal()
        );
      }
    });
  }

  /**
   * Closes the cancellation policy modal.
   */
  closeModal(): void {
    this.policyModalRef.close();
  }
}
